import { request } from '../request';

export const providerApi = {
  listProviders: () => request('/models'),

  configureProvider: (providerId, body) =>
    request(`/models/${encodeURIComponent(providerId)}/config`, {
      method: 'PUT',
      body: JSON.stringify(body)
    }),

  /**
   * @param {{ scope?: string; agent_id?: string }} [query] - 多智能体下按 workspace 拉取当前激活模型
   */
  getActiveModels: (query) => {
    const params = new URLSearchParams();
    const { scope, agent_id: agentId } = query || {};
    if (scope !== undefined && scope !== null) params.set('scope', String(scope));
    if (agentId !== undefined && agentId !== null) params.set('agent_id', String(agentId));
    const qs = params.toString();
    return request(`/models/active${qs ? `?${qs}` : ''}`);
  },

  setActiveLlm: (body) =>
    request('/models/active', {
      method: 'PUT',
      body: JSON.stringify(body)
    }),

  createCustomProvider: (body) =>
    request('/models/custom-providers', {
      method: 'POST',
      body: JSON.stringify(body)
    }),

  deleteCustomProvider: (providerId) =>
    request(`/models/custom-providers/${encodeURIComponent(providerId)}`, { method: 'DELETE' }),

  addModel: (providerId, body) =>
    request(`/models/${encodeURIComponent(providerId)}/models`, {
      method: 'POST',
      body: JSON.stringify(body)
    }),

  removeModel: (providerId, modelId) =>
    request(`/models/${encodeURIComponent(providerId)}/models/${encodeURIComponent(modelId)}`, { method: 'DELETE' }),

  configureModel: (providerId, modelId, body) =>
    request(`/models/${encodeURIComponent(providerId)}/models/${encodeURIComponent(modelId)}/config`, {
      method: 'PUT',
      body: JSON.stringify(body)
    }),
  testProviderConnection: (providerId, body) =>
    request(`/models/${encodeURIComponent(providerId)}/test`, {
      method: 'POST',
      body: body ? JSON.stringify(body) : undefined
    }),

  testModelConnection: (providerId, body) =>
    request(`/models/${encodeURIComponent(providerId)}/models/test`, {
      method: 'POST',
      body: JSON.stringify(body)
    }),
  discoverModels: (providerId, body) =>
    request(`/models/${encodeURIComponent(providerId)}/discover`, {
      method: 'POST',
      body: body ? JSON.stringify(body) : undefined
    }),

  probeMultimodal: (providerId, modelId) =>
    request(`/models/${encodeURIComponent(providerId)}/models/${encodeURIComponent(modelId)}/probe-multimodal`, {
      method: 'POST'
    })
};
